import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const AddToBuyListModalSupplierFragmentDoc = gql`
  fragment AddToBuyListModalSupplier on Supplier {
    id
    name
  }
` as unknown as DocumentNode<Types.AddToBuyListModalSupplierFragment, unknown>
